<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button
            class="breadcrumb-back"
            @click="
              $router && $router.back ? $router.back() : window.history.back()
            "
          >
            返回
          </button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.belong_cn }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.schoolname }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">校友中心校友列表</span>
        </div>
        <!-- 校友分组  -->
        <div class="alumni-list">
          <div
            class="alumni-group"
            v-for="group in alumniList"
            :key="group.year"
          >
            <div class="alumni-group-header">
              <span class="alumni-year">校友毕业{{ group.nianji }}届</span>
            </div>
            <div class="alumni-classes">
              <div
                class="alumni-class-card"
                v-for="cls in group.xiangxi"
                :key="cls"
              >
                {{ cls.banji }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="list.length === 0" class="no-data">暂无数据</div> -->
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="handlePageChange"
          class="pagination-bar"
        />
      </div>
      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right
          :marketBannerSmall="marketBannerSmall"
          :marTop="false"
        ></v-right>
      </div>
    </div>
  </div>
</template>

<script>
import sign from '@/auth/sign'
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import { getAlumnsBiyejieLists, getEduDetails } from '@/axios/education'
export default {
  name: 'TextCourseware',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter
  },
  data () {
    return {
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      school_id: parseInt(this.$route.query.school_id) || 1,
      type: 1,
      guidInfo: {
        name: '',
        zhiwu: ''
      },
      alumniList: []
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  created () {
    this.getguidInfo()
    this.getLists()
  },
  methods: {
    getguidInfo () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.school_id,
        type: 1
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.guidInfo = {
            belong_cn: data.belong_cn || '',
            schoolname: data.schoolname || ''
          }
        }
      })
    },
    getLists () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.school_id,
        stype: 1,
        page: this.page
      }
      const signO = sign(params)
      params.sign = signO
      getAlumnsBiyejieLists(params)
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data.data
            this.alumniList = data.lists || []
            this.total = data.total || 0
          } else {
            this.alumniList = []
            this.total = 0
          }
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
    },
    handlePageChange (page) {
      this.page = page
      this.getLists()
    }
  }
}
</script>

<style lang="less" scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #f9f9f9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  &:hover {
    background: #f2f2f2;
    border-color: #ccc;
  }
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #ef8432;
  font-weight: bold;
}
.pagination-bar {
  text-align: center;
  margin-top: 20px;
}
.no-data {
  text-align: center;
  color: #aaa;
  margin: 30px 0;
}
.alumni-list {
  .alumni-group {
    background: #F2F8FF;
    background-image: url('../../assets/images/xy-bg.png');
    background-repeat: no-repeat;
    background-position: top right;
    background-size: 120px 120px;
    border-radius: 10px;
    margin-bottom: 24px;
    padding: 18px;
    position: relative;
    .alumni-group-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .alumni-year {
        color: #3FBABE;
        font-weight: bold;
        padding: 4px 8px;
        font-size: 14px;
        border-radius: 4px;
        background: rgba(63, 186, 190, 0.1);
        border: 0.5px solid rgba(63, 186, 190, 0.5);
      }
    }
    .alumni-classes {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      .alumni-class-card {
        background: rgba(63, 186, 190, 0.1);
        border-radius: 6px;
        padding: 8px 24px;
        font-size: 14px;
        color: #3D3D3D;
        cursor: pointer;
        transition: background 0.2s;
        &:hover {
          background: #d0f0ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/schoolmate.vue